/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */
import './prototypes';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import * as amplitude from 'amplitude-js';
import { Logger } from '@app/core';

console.log('Version: ' + environment.version + ' (' + environment.build + ' build)');

console.log('%cSTOP!!!', 'color: red;font-size: 96px;');
console.log(
  '%cThis is a browser feature intended for developers. ' +
    'If someone told you to copy and paste something here to enable an Edgeless feature or "hack" someone\'s account, ' +
    'it is a scam and will give them access to your Edgeless account.',
  'color: black;font-size: 25px;'
);

if (environment.production) {
  Logger.enableProductionMode();
  enableProdMode();
}

amplitude.getInstance().init(environment.amplitude.apiKey, null, {
  saveEvents: true,
  includeUtm: true,
  includeReferrer: true,
  batchEvents: true,
  includeGclid: true,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/main.ts